import { render, staticRenderFns } from "./TenantRegister.vue?vue&type=template&id=88be3fe2&scoped=true"
import script from "./TenantRegister.vue?vue&type=script&lang=js"
export * from "./TenantRegister.vue?vue&type=script&lang=js"
import style0 from "./TenantRegister.vue?vue&type=style&index=0&id=88be3fe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88be3fe2",
  null
  
)

export default component.exports